<script setup lang="ts">
import { getCurrentInstance, onMounted, ref, type ComponentInternalInstance } from 'vue';
import ConfirmDialog from '../vue-components/ConfirmDialog.vue';
import { getParentContainer } from '../js-utils/_shared/utils';
import { formToObject, invokeMultipartEncoding } from '../js-utils/_shared/form-utils';

const props = defineProps({
    apiUrl: String,
    idBenefic: String,
    idLastTurno: String,
    fechaLastTurno: String,
    horaLastTurno: String,
    idCentro: String,
    cmNombre: String,
});

const showConfirm = ref(false);

let chequeosFormAdd: HTMLFormElement | null = null;
let chequeosFormRemove: HTMLFormElement | null = null;
let displayOnError: HTMLElement | null = null;
let btnSolicitarTurno: HTMLButtonElement | null = null;
let btnCancelarTurno: HTMLButtonElement | null = null;

let openHours: NodeListOf<HTMLElement> | null = null;
let hourSelectors: NodeListOf<HTMLButtonElement> | null = null;

let dateSelection: string | null = null;
let hourSelection: string | null = null;

function openConfirm() {
    showConfirm.value = true;
}

async function handleConfirm() {
    if (chequeosFormRemove) {
        btnCancelarTurno!.disabled = true;
        btnCancelarTurno!.innerText = 'Procesando...';
        const formObj = formToObject(chequeosFormRemove);
        formObj['idLastTurno'] = props.idLastTurno!;
        formObj['fechaLastTurno'] = props.fechaLastTurno!;
        formObj['horaLastTurno'] = props.horaLastTurno!;
        formObj['idCentro'] = props.idCentro!;
        try {
            const response = await invokeMultipartEncoding(formObj, props.apiUrl + '/remove');
            if (response.data?.status) {
                // Error
                btnCancelarTurno!.disabled = false;
                btnCancelarTurno!.innerText = 'Cancelar Turno';
                displayOnError!.innerText = response.data?.message ?? 'Error';
                displayOnError!.style.display = 'block';
            } else {
                // Success
                window.location.reload();
            }
        } catch (error) {
            btnCancelarTurno!.disabled = false;
            btnCancelarTurno!.innerText = 'Cancelar Turno';
            displayOnError!.innerText = error?.toString() ?? 'Error interno';
            displayOnError!.style.display = 'block';
        }
    }
}

function handleCancel() {}

onMounted(async (callback: () => void, target?: ComponentInternalInstance | null) => {
    const instance = target || getCurrentInstance()!;

    const container = getParentContainer((instance.proxy!.$el! as HTMLElement)!.parentElement!);
    chequeosFormAdd = container.querySelector('.js-chequeos-form-add')! as HTMLFormElement; // the form to be submitted
    chequeosFormRemove = container.querySelector('.js-chequeos-form-remove')! as HTMLFormElement;
    displayOnError = container.querySelector('.js-display-on-error')! as HTMLElement;
    btnSolicitarTurno = container.querySelector('.js-solicitar-turno')!;
    btnCancelarTurno = container.querySelector('.js-cancelar-turno')!;

    openHours = container.querySelectorAll('.js-open-hours');
    hourSelectors = container.querySelectorAll('.js-hour-selector');

    if (btnSolicitarTurno && props.apiUrl && props.idBenefic && props.idCentro && props.cmNombre) {
        btnSolicitarTurno.addEventListener('click', async (ev) => {
            ev.preventDefault();
            if (dateSelection && hourSelection && chequeosFormAdd) {
                btnSolicitarTurno!.disabled = true;
                btnSolicitarTurno!.innerText = 'Procesando...';

                const formObj = formToObject(chequeosFormAdd);
                formObj['idBenefic'] = props.idBenefic!;
                formObj['idCentro'] = props.idCentro!;
                formObj['cmNombre'] = props.cmNombre!;
                formObj['fecha'] = dateSelection;
                formObj['hora'] = hourSelection;
                try {
                    const response = await invokeMultipartEncoding(formObj, props.apiUrl! + '/add');
                    if (response.data?.status) {
                        // Error
                        btnSolicitarTurno!.disabled = false;
                        btnSolicitarTurno!.innerText = 'Solicitar turno';
                        displayOnError!.innerText = response.data?.message ?? 'Error';
                        displayOnError!.style.display = 'block';
                    } else {
                        // Success
                        window.location.reload();
                    }
                } catch (error) {
                    btnSolicitarTurno!.disabled = false;
                    btnSolicitarTurno!.innerText = 'Solicitar turno';
                    displayOnError!.innerText = error?.toString() ?? 'Error interno';
                    displayOnError!.style.display = 'block';
                }
            }
        });
    }

    if (btnCancelarTurno && props.apiUrl && props.idLastTurno) {
        btnCancelarTurno.addEventListener('click', async (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            if (chequeosFormRemove) {
                openConfirm();
            }
        });
    }
    if (hourSelectors) {
        hourSelectors.forEach((btn) => {
            btn.addEventListener('click', (ev) => {
                hourSelectors!.forEach((el) => {
                    if (el !== btn) el.classList.remove('active');
                });
                btn.classList.toggle('active');

                const isActiveHour: HTMLButtonElement | null = container!.querySelector('.js-hour-selector.active');
                if (btnSolicitarTurno) {
                    if (isActiveHour) {
                        dateSelection = isActiveHour.value.split('|')[0]!;
                        hourSelection = isActiveHour.value.split('|')[1]!;
                        btnSolicitarTurno.removeAttribute('disabled');
                    } else {
                        dateSelection = null;
                        hourSelection = null;
                        btnSolicitarTurno.setAttribute('disabled', 'true');
                    }
                }
            });
        });
    }

    if (openHours) {
        openHours.forEach((btn) => {
            btn.addEventListener('click', (ev) => {
                const selectedDateDropdown = btn.parentElement;
                if (selectedDateDropdown) selectedDateDropdown.classList.toggle('opened');
            });
        });
    }
});
</script>

<template>
    <ConfirmDialog
        v-model:show="showConfirm"
        message="¿Deseás cancelar el turno?"
        confirm-label="Si"
        cancel-label="No"
        @confirm="handleConfirm"
        @cancel="handleCancel" />
</template>
